import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';
@Injectable()
export class BaseApiService {
  //==================Base Url=================================
  //baseUrl: string = 'http://localhost:8001/api/sa/';//local
  //baseUrl: string = 'http://52.74.96.220/api/sa/';//AWS
  // baseUrl: string = 'https://eguruskindev.api.tatamotors/api/sa/';//Sandbox
  // baseUrl: string = 'https://skindevreplica-tls.api.tatamotors/api/sa/';//Sandbox python3
  // baseUrl: string = 'https://skindev-pv.api.tatamotors/api/sa/';//sandbox PV sub
  // baseUrl: string = 'https://skinprod-pv.api.tatamotors/api/sa/'; //sandbox prod PV sub
  baseUrl: string = 'https://skinprod.api.tatamotors/api/sa/'; //prod CV
  //baseUrl: string = 'https://eguruskin.api.tatamotors/api/sa/';//Prod

  // logoutURL:string='https://eguruskindev.api.tatamotors/api/sa/portal/logout'; //sandbox
  // logoutURL:string='https://skindevreplica-tls.api.tatamotors/api/sa/portal/logout'; // sandbox python3
  // logoutURL: string = 'https://skindev-pv.api.tatamotors/api/sa/portal/logout'; //sandbox PV sub
  // logoutURL: string = 'https://skinprod-pv.api.tatamotors/api/sa/portal/logout'; //sandbox prod PV sub
  logoutURL: string = 'https://skinprod.api.tatamotors/api/sa/portal/logout'; //prod CV
  //logoutURL: string = 'https://eguruskin.api.tatamotors/api/sa/app/logout';
  //logoutURL: string = 'https://localhost:8001/api/sa/app/logout';
  //logoutURL: string = 'https://52.74.96.220/api/sa/app/logout';
  //==================Login Url=================================
 
  // loginURL: string = 'https://skinprod-pv.api.tatamotors/api/sa/portal/login/'; //sandbox prod PV sub
  loginURL: string = 'https://skinprod.api.tatamotors/api/sa/portal/login/'; //prod CV
  // loginURL: string = 'https://skindev-pv.api.tatamotors/api/sa/portal/login/'; //sandbox PV sub
  // loginURL: string = 'https://eguruskindev.api.tatamotors/api/sa/portal/login/'; //sandbox
  // loginURL: string = 'https://skindevreplica-tls.api.tatamotors/api/sa/portal/login/';  //sandbox python3
  //loginURL: string = 'http://52.74.96.220/api/sa/portal/login/';
  //loginURL: string = 'https://eguruskin.api.tatamotors/api/sa/app/login/';
  //loginURL: string = 'http://localhost:8001/api/sa/portal/login/';
  //==================Upload Data Url=================================
  probingURL: string = this.baseUrl + 'pq/upload_data/';
  nsdURL: string = this.baseUrl + 'nsd/upload_data/';
  warrantyURL: string = this.baseUrl + 'war/upload_data/';
  ewURL: string = this.baseUrl + 'ew/upload_data/';
  amcURL: string = this.baseUrl + 'amc/upload_data/';
  sechduleServiceURL: string = this.baseUrl + 'sche_ser/upload_data/';
  jobEstimateURL: string = this.baseUrl + 'std_est/upload_data/';
  circularURL: string = this.baseUrl + 'cir/upload_data/';
  uploadCircularPdfURL = this.baseUrl + 'circulars/update_pdf/';
  //==================View Data Url=================================
  probingGetDataURL: string = this.baseUrl + 'pq/listAllData/';
  nsdGetDataURL: string = this.baseUrl + 'nsd/listAllData/';
  ewGetDataURL: string = this.baseUrl + 'ew/listAllData/';
  warrantyGetDataURL: string = this.baseUrl + 'war/listAllData/';
  amcGetDataURL: string = this.baseUrl + 'amc/listAllData/';
  schServiceGetDataURL: string = this.baseUrl + 'sche_ser/listAllData/';
  jobEstimateGetDataURL: string = this.baseUrl + 'std_est/listAllData/';
  circularDataURL: string = this.baseUrl + 'cir/listAllData/';
  deleteCircularDataURL: string = this.baseUrl + 'circulars/delete_cir/';
  circularExcelData: string = this.baseUrl + 'cir/excelAllData/';
  getUserPositionURL: string = this.baseUrl + 'positions/listAllData/';
  updateUserpositionURL: string = this.baseUrl + 'positions/update_status/';
  //==================Notification Url=================================

  regionURL = this.baseUrl + 'notifications/search/regions/';
  stateURL = this.baseUrl + 'notifications/search/states/';
  cityURL = this.baseUrl + 'notifications/search/cities/';
  dealerURL = this.baseUrl + 'notifications/search/dealers/';
  divisionURL = this.baseUrl + 'notifications/search/divisions/';
  uploadNotificationURL = this.baseUrl + 'notifications/add/';
  notificationTypeURL = this.baseUrl + 'notifications/types/';
  viewNotificationURL = this.baseUrl + 'notifications/all/';
  readNotificationURL = this.baseUrl + 'notifications/read_details/';
  deleteNotificationURL = this.baseUrl + 'notifications/delete/';
  notificationDetialByIdURL = this.baseUrl + 'notifications/details_by_id/';
  updateNotificationURL = this.baseUrl + 'notifications/update/';

  options: RequestOptions;
  body: any;
  token: string;

  constructor(private http: Http, private router: Router) {
    console.log('Base service called');
  }
  callLoginApi(userName, password) {
    return new Promise((resolve, reject) => {
      this.body = {
        "username": userName,
        "password": password,
        "device_id": "87946545616461316846169845161148461616844616",
        "app_version": "0.01",
        "app_name": "com.tatamotors.sa"
      };

      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');

      let options = new RequestOptions({ headers: headers });

      this.http.post(this.loginURL, this.body, options).subscribe(
        data => {

          var jsonObj = JSON.parse(JSON.stringify(data.json()));
          this.token = jsonObj.token.access_token;
          localStorage.setItem('token', this.token);
          resolve(data.json());
        },
        error => {
          console.log(JSON.stringify(error.json()));
          reject(error.json());

        }
      )
    });
  }


  callLogoutApi(url) {
    return new Promise((resolve, reject) => {


      var headers = new Headers();
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
      let options = new RequestOptions({ headers: headers });

      this.http.post(url, null, options).subscribe(
        data => {


        },
        error => {


        }
      )
    });
  }
  callUploadDataApi(formData: FormData, url) {
    return new Promise((resolve, reject) => {


      var headers = new Headers();
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));

      let options = new RequestOptions({ headers: headers });

      this.http.post(url, formData, options).subscribe(
        data => {

          var jsonObj = JSON.parse(JSON.stringify(data.json()));
          console.log(JSON.stringify(data.json()));
          resolve(data.json());
        },
        error => {
          console.log(JSON.stringify(error.json()));
          if (error.status === 401) {
            alert('Login error');
            this.router.navigate(['/login']);
          }
          else {
            reject(error.json());
          }


        }
      )
    });
  }
  /**
   * Method to get List data
   * @param startIndex offset
   * @param noOfRecords size
   * @param masterType  Type
   * @param apiURL  Api endpoint URL
   */
  callGetDataApi(startIndex, noOfRecords, masterType, apiURL) {
    return new Promise((resolve, reject) => {

      this.body = {
        "master_type": masterType,
        "offset": startIndex,
        "size": noOfRecords
      };
      var headers = new Headers();
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: headers });

      this.http.post(apiURL, this.body, options).subscribe(
        data => {

          var jsonObj = JSON.parse(JSON.stringify(data.json()));
          resolve(data.json());
        },
        error => {
          console.log(JSON.stringify(error.json()));
          if (error.status === 401) {
            alert('Login error');
            this.router.navigate(['/login']);
          }
          else {
            reject(error.json());
          }


        }
      )
    });
  }
  /**
   * Method to get Region/State/City/Dealer/Division data
   * @param bodyData Post Body
   * @param url      Api URL
   */
  callLocationsApi(bodyData: any, url) {
    return new Promise((resolve, reject) => {


      var headers = new Headers();
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');

      let options = new RequestOptions({ headers: headers });

      this.http.post(url, bodyData, options).subscribe(
        data => {

          var jsonObj = JSON.parse(JSON.stringify(data.json()));

          resolve(data.json());
        },
        error => {
          console.log(JSON.stringify(error.json()));
          if (error.status === 401) {
            alert('Login error');
            this.router.navigate(['/login']);
          }
          else {
            reject(error.json());
          }

        }
      )
    });
  }
  /**
    * Method to get Notification Type
    * @param
    * @param url
    */
  callGetNotificationTypeApi(url) {
    return new Promise((resolve, reject) => {


      var headers = new Headers();
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');

      let options = new RequestOptions({ headers: headers });

      this.http.post(url, null, options).subscribe(
        data => {

          var jsonObj = JSON.parse(JSON.stringify(data.json()));

          resolve(data.json());
        },
        error => {
          console.log(JSON.stringify(error.json()));
          if (error.status === 401) {
            alert('Login error');
            this.router.navigate(['/login']);
          }
          else {
            reject(error.json());
          }

        }
      )
    });
  }
  /**
   *
   * @param url Method to call view notification APi
   */
  viewNotificationApi(url) {
    return new Promise((resolve, reject) => {

      var headers = new Headers();
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');

      let options = new RequestOptions({ headers: headers });

      this.http.post(url, null, options).subscribe(
        data => {

          var jsonObj = JSON.parse(JSON.stringify(data.json()));

          resolve(data.json());
        },
        error => {
          console.log(JSON.stringify(error.json()));
          if (error.status === 401) {
            alert('Login error');
            this.router.navigate(['/login']);
          }
          else {
            reject(error.json());
          }

        }
      )
    });
  }


  /**
   *
   * @param url Method to call read notification APi
   */
  readNotificationApi(url, notificationId) {
    return new Promise((resolve, reject) => {
      this.body = {
        "notification_id": notificationId
      };
      var headers = new Headers();
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');

      let options = new RequestOptions({ headers: headers });

      this.http.post(url, this.body, options).subscribe(
        data => {

          var jsonObj = JSON.parse(JSON.stringify(data.json()));

          resolve(data.json());
        },
        error => {
          console.log(JSON.stringify(error.json()));
          if (error.status === 401) {
            alert('Login error');
            this.router.navigate(['/login']);
          }
          else {
            reject(error.json());
          }

        }
      )
    });
  }


  /**
   *
   * @param apiURL Method to get delete notification
   * @param notificationId
   */
  callDeleteNotificationApi(apiURL, notificationId) {
    return new Promise((resolve, reject) => {

      this.body = {
        "notification_id": notificationId
      };
      var headers = new Headers();
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: headers });

      this.http.post(apiURL, this.body, options).subscribe(
        data => {

          var jsonObj = JSON.parse(JSON.stringify(data.json()));
          resolve(data.json());
        },
        error => {
          console.log(JSON.stringify(error.json()));
          if (error.status === 401) {
            alert('Login error');
            this.router.navigate(['/login']);
          }
          else {
            reject(error.json());
          }


        }
      )
    });
  }

  /**
   *
   * @param apiURL Method to get delete circular
   * @param circularId
   */
  callDeleteCircularApi(apiURL, formData: FormData) {
    return new Promise((resolve, reject) => {


      var headers = new Headers();
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
      let options = new RequestOptions({ headers: headers });
      this.http.post(apiURL, formData, options).subscribe(
        data => {

          var jsonObj = JSON.parse(JSON.stringify(data.json()));
          console.log(JSON.stringify(data.json()));
          resolve(data.json());
        },
        error => {
          console.log(JSON.stringify(error.json()));
          if (error.status === 401) {
            alert('Login error');
            this.router.navigate(['/login']);
          }
          else {
            reject(error.json());
          }


        }
      )
    });
  }
  callUpdateUserPositionApi(userPositionId, type, positionType, positionStatus) {
    return new Promise((resolve, reject) => {

      this.body = {
        "ROW_ID": userPositionId,
        "type": type,
        "position_type": positionType,
        "position_status": positionStatus

      };



      var headers = new Headers();
      headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
      headers.append("Accept", 'application/json');
      headers.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: headers });

      this.http.post(this.updateUserpositionURL, this.body, options).subscribe(
        data => {

          var jsonObj = JSON.parse(JSON.stringify(data.json()));
          resolve(data.json());
        },
        error => {
          console.log(JSON.stringify(error.json()));
          if (error.status === 401) {
            alert('Login error');
            this.router.navigate(['/login']);
          }
          else {
            reject(error.json());
          }


        }
      )
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/base-api.service.ts